module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/hero-desktop-22fbe492381f757838d35873c256e5ee.png";